<script>
export default {
    name: 'DeviceRealtimeStatus',
    props: {
      status: {
        type: String,
        default: 'inactive',
        validator: val => ['active', 'inactive', 'info', 'danger'].includes(val),
      }
    },
}
</script>

<template> 
    <div 
      class="DeviceRealtimeStatus"
      :data-status="status"
    > 
      <span data-part="icon">
        <slot></slot>
      </span>
    </div>
</template>

<style lang="scss" scoped>
.DeviceRealtimeStatus {
  width: 3rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: var(--colors-gray-200);
  border-radius: var(--radius-md);

  [data-part="icon"] {
    font-size: 1.67rem;
    line-height: 0;
    color: var(--colors-gray-400);
  }

  &[data-status="active"] {
    background-color: var(--colors-success-500);

    [data-part="icon"] {
      color: var(--colors-white);
    }
  }
  &[data-status="danger"] {
    background-color: var(--colors-danger-500);

    [data-part="icon"] {
      color: var(--colors-white);
    }
  }
  &[data-status="info"] {
    background-color: var(--colors-info-200);
    [data-part="icon"] {
      color: var(--colors-info-800);
    }
  }

}
</style>
